<template>
  <div class="tabs">
    <span
      v-for="method in filteredPaymentMethodsConfig"
      :key="method.key"
      class="tab"
      @click="portalActiveTab(method.key)"
      :class="activeTab == method.key ? 'active' : ''"
    >
      <div>{{ method.label }}</div>
      <aTag class="ml-10" :color="method.color">
        {{ method.value }}
      </aTag>
    </span>
  </div>
</template>

<script>
import formatThings from "@/mixins/general/formatThings.js";

export default {
  name: "ContractPaymentMethodsValuesPanel",
  props: {
    paymentMethods: Array,
    activeTab: String,
    tempContract: Object,
    keyPrefix: String,
    keySuffix: String,
  },
  mixins: [formatThings],
  data() {
    return {
      thirdPartyRows: [],
      paymentMethodsConfig: [
        {
          key: "billing-ticket",
          label: "Boleto",
          color: "blue",
          value: `R$ 0`,
        },
        {
          key: "payment-card",
          label: "Carta de Crédito",
          color: "blue",
          value: `R$ 0`,
        },
        {
          key: "credit-card",
          label: "Cartão de Crédito",
          color: "blue",
          value: `R$ 0`,
        },
        {
          key: "custom-payment",
          label: "Personalizado",
          color: "blue",
          value: `R$ 0`,
        },
        {
          key: "bank-transfer",
          label: "Transferência bancária",
          color: "blue",
          value: `R$ 0`,
        },
        {
          key: "payment-link",
          label: "Link de Pagamento",
          color: "blue",
          value: `R$ 0`,
        },
        {
          key: "third-party",
          label: "Terceiros",
          color: "purple",
          value: `0`,
        },
      ],
    };
  },
  mounted() {
    this.handleEvent();
  },
  created() {
    this.$on("updateTotalValue", this.handleEvent);
  },
  computed: {
    filteredPaymentMethodsConfig() {
      // Filter and order the payment methods to include only those that exist in `paymentMethods`
      return this.paymentMethods
        .map((key) => this.paymentMethodsConfig.find((method) => method.key === key))
        .filter(Boolean);
    },
  },
  methods: {
    portalActiveTab(active) {
      this.$emit("portalActiveTab", active);
    },
    handleEvent() {
      this.tempContract[`third_party_payment_rows${this.keySuffix}`] !==
        undefined &&
        (this.thirdPartyRows = JSON.parse(
          this.tempContract[`third_party_payment_rows${this.keySuffix}`]
        ));

      this.paymentMethodsConfig = [
        {
          key: "billing-ticket",
          label: "Boleto",
          color: "blue",
          value: this.formatAnyPricePtBr(
            this.tempContract[
              `payment_methods_billing_ticket_total_value${this.keySuffix}`
            ]
          ),
        },
        {
          key: "payment-card",
          label: "Carta de Crédito",
          color: "blue",
          value: this.formatAnyPricePtBr(
            this.tempContract[
              `payment_methods_payment_card_total_value${this.keySuffix}`
            ]
          ),
        },
        {
          key: "credit-card",
          label: "Cartão de Crédito",
          color: "blue",
          value: this.formatAnyPricePtBr(
            this.tempContract[
              `payment_methods_credit_card_total_value${this.keySuffix}`
            ]
          ),
        },
        {
          key: "custom-payment",
          label: "Personalizado",
          color: "blue",
          value: this.formatAnyPricePtBr(
            this.tempContract[
              `payment_methods_custom_payment_total_value${this.keySuffix}`
            ]
          ),
        },
        {
          key: "bank-transfer",
          label: "Transferência bancária",
          color: "blue",
          value: this.formatAnyPricePtBr(
            this.tempContract[
              `payment_methods_bank_transfer_total_value${this.keySuffix}`
            ]
          ),
        },
        {
          key: "payment-link",
          label: "Link de Pagamento",
          color: "blue",
          value: this.formatAnyPricePtBr(
            this.tempContract[
              `payment_methods_payment_link_total_value${this.keySuffix}`
            ]
          ),
        },
        {
          key: "third-party",
          label: "Terceiros",
          color: "purple",
          value: this.thirdPartyRows.length,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  border: 0;
  border-bottom: 1px solid #ddd;
  background: #eee;
  padding: 15px 15px 5px;

  .tab {
    background: #ffffff;
    border: 1px solid #ddd;
    border-top: 2px solid #bbb;
    margin-bottom: 10px;
    border-radius: 6px;
    div {
      margin-bottom: 5px;
    }
  }

  .tab.active {
    border-top: 2px solid #515151;
    font-weight: 600;
    color: #292828;
    background: #ffffff;
  }
}
</style>
